import React, {useRef, useState} from 'react'

import ReactCrop, {centerCrop, Crop, makeAspectCrop,} from 'react-image-crop'

import 'react-image-crop/dist/ReactCrop.css'
import {
    AvatarAddModalContent,
    AvatarModalBackground,
    AvatarModalBody,
    AvatarModalContent,
    AvatarModalHeader,
    EditAvatarModalContent,
    ModalFooter
} from "../../../../components/ui/Modal";
import {Body1Pointer, H3} from "../../../../components/Font";
import {ModalActiveBtn, ModalDefaultBtn} from "../../../../components/ui/Button";
import {useAppDispatch, useAppSelector} from "../../../../app/hooks";
import {DeleteAvatar, PostAvatar} from "../api/slice";
import {useTheme} from "styled-components";
import {Union} from "../../../../icon/Icon";
import {UnionDiv} from "../../../../components/ui/Content";


function centerAspectCrop(
    mediaWidth: number,
    mediaHeight: number,
    aspect: number,
) {
    return centerCrop(
        makeAspectCrop(
            {
                unit: 'px',
                width: 400
            },
            aspect,
            mediaWidth,
            mediaHeight,
        ),
        mediaWidth,
        mediaHeight,
    )
}

let refInput: HTMLInputElement;

interface EditAvatarModalProps {
    onSubmit: () => void
    onGoBack: () => void
}

export const EditAvatarModal = ({onSubmit, onGoBack}: EditAvatarModalProps) => {

    const account = useAppSelector(state => state.account)
    const initCrop : Crop= {
        x: 0,
        y: 0,
        width: 400,
        height: 400,
        unit: "px",
    }
    const dispatch = useAppDispatch()
    const [srcImg, setSrcImg] = useState('');
    const [image, setImage] = useState<HTMLImageElement | null>(null);
    const [crop, setCrop] = useState(initCrop);
    const inputRef = useRef(refInput);
    const imgRef = useRef<HTMLImageElement>(null)
    const aspect = 1
    const Theme = useTheme()

    const handleImage = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files)
            setSrcImg(URL.createObjectURL(event.target.files[0]));
    };

    const getCroppedImg = async () => {
        if (image) {
            const canvas = document.createElement("canvas");
            const scaleX = image.naturalWidth / image.width;
            const scaleY = image.naturalHeight / image.height;
            canvas.width = crop.width;
            canvas.height = crop.height;
            const ctx = canvas.getContext("2d");
            if (ctx) {
                ctx.drawImage(
                    image,
                    crop.x * scaleX,
                    crop.y * scaleY,
                    crop.width * scaleX,
                    crop.height * scaleY,
                    0,
                    0,
                    crop.width,
                    crop.height
                );
            }
            canvas.toBlob(function (blob) {
                const formData = new FormData();
                if (blob !== null) {
                    formData.append('avatar', blob);
                    dispatch(PostAvatar(formData))
                }
            });
        }
    };

    function onImageLoad(e: React.SyntheticEvent<HTMLImageElement>) {
        setImage(e.currentTarget)
        if (aspect) {
            const {width, height} = e.currentTarget
            setCrop(centerAspectCrop(width, height, aspect))
        }
    }

    return (
        <>
            {srcImg &&
                <AvatarModalBackground>
                    <EditAvatarModalContent>
                        <AvatarModalHeader>
                            <H3>Фотография профиля</H3>
                            <UnionDiv onClick={onGoBack}>
                                <Union/>
                            </UnionDiv>

                        </AvatarModalHeader>
                        <AvatarModalBody>
                            <ReactCrop
                                crop={crop}
                                onChange={(crop) => setCrop(crop)}
                                aspect={aspect}
                                circularCrop={true}
                            >
                                <img
                                    ref={imgRef}
                                    alt="Crop me"
                                    src={srcImg}
                                    onLoad={onImageLoad}
                                />
                            </ReactCrop>
                        </AvatarModalBody>
                        <ModalFooter className={'avatar-footer'}>
                            <ModalDefaultBtn className={'avatar-def-btn'} onClick={onGoBack}>
                                Отмена
                            </ModalDefaultBtn>
                            <ModalActiveBtn
                                className={'avatar-active-btn'}
                                onClick={() => {
                                    getCroppedImg()
                                    onSubmit()
                                }}>
                                Сохранить
                            </ModalActiveBtn>
                        </ModalFooter>
                    </EditAvatarModalContent>
                </AvatarModalBackground>
                || <>
                    <input type="file"
                           ref={inputRef}
                           onChange={handleImage}
                           accept="image/jpeg,image/png"
                           hidden
                    />

                    {account?.avatar &&
                        <AvatarModalContent>
                            <Body1Pointer onClick={() => inputRef.current.click()}>
                                Изменить фотографию
                            </Body1Pointer>
                            <Body1Pointer
                                onClick={() => {
                                    onGoBack()
                                    dispatch(DeleteAvatar())
                                }}
                                color={Theme.color.danger}>
                                Удалить фотографию
                            </Body1Pointer>
                        </AvatarModalContent>
                        || <AvatarAddModalContent>
                            <Body1Pointer onClick={() => inputRef.current.click()}>
                                Добавить фотографию
                            </Body1Pointer>
                        </AvatarAddModalContent>
                    }
                </>
            }
        </>
    )
}